import BoardOrganizer from "../boardOrganizer/boardOrganizer.service";

export default class BaseDataLoader {
  retrieveBoardLogInfo(board) {
    const position = BoardOrganizer._findPosition(board.id);
    return { ...board, position };
  }
}
